import { EventPlace, trackEngagement } from "helpers/analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackLearnMoreClicked = (location: "not-in-organization" | "connected") => {
  trackEngagement("OpenWidget: 'Learn more' button clicked", EventPlace.Settings, { location });
};
